var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _vm.getFormConfig
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.clearPLabel(_vm.getFormConfig.label)),
                  },
                }),
                _vm.addPriceType && _vm.isAdd
                  ? _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            "（ 批增按" +
                              (_vm.addPriceType === "M" ? "月" : "天") +
                              "收取保费 ）"
                          ) +
                          "\n\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.getFormConfig && _vm.getFormConfig.notice
            ? _c("el-alert", {
                staticStyle: { "margin-bottom": "10px" },
                attrs: {
                  title: _vm.getFormConfig.notice.content,
                  "show-icon": "",
                  type: "warning",
                },
              })
            : _vm._e(),
          _c("avue-form", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            ref: "refPeriod",
            attrs: { option: _vm.optionPeriod },
            on: { submit: _vm.onSubmitPeriod },
            scopedSlots: _vm._u([
              {
                key: "today",
                fn: function (ref) {
                  var value = ref.value
                  return [_c("span", [_vm._v(_vm._s(value))])]
                },
              },
              {
                key: "expiryDate",
                fn: function (ref) {
                  var value = ref.value
                  return [_c("span", [_vm._v(_vm._s(value))])]
                },
              },
              {
                key: "periodDay",
                fn: function (ref) {
                  var value = ref.value
                  return [
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(_vm._s(value) + " 天"),
                    ]),
                  ]
                },
              },
              {
                key: "menuForm",
                fn: function (ref) {
                  return [
                    !_vm.optionPeriod.submitBtn
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.onCheckPeriodResult(false)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t修改\n\t\t\t\t")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.formPeriod,
              callback: function ($$v) {
                _vm.formPeriod = $$v
              },
              expression: "formPeriod",
            },
          }),
        ],
        1
      ),
      _c("dialog-endorse-time-hint", {
        ref: "refTimeHint",
        attrs: { "last-time-data": _vm.getLastDate },
        on: { onEndorseTimeSure: _vm.onShowInsureData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }